var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('content-wrapper',[(this.loading)?_c('loader'):_vm._e(),(_vm.post)?_c('post',{key:_vm.post.id,attrs:{"post":_vm.post}}):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }